'use client';

import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

/**
 * 页面切换转场（v0.8 体验强化包）：
 * 路由变化时给内容容器加 180ms 淡入 + 轻上移动画，
 * 让站内跳转不再像刷新网页。不重挂载子树（保留页面 state）。
 */
export default function RouteTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const prev = useRef<string | undefined>(pathname);
  const [anim, setAnim] = useState(false);

  useEffect(() => {
    if (prev.current === pathname) return;
    prev.current = pathname;
    // 先清除再 rAF 重加，确保同路径连续跳转也能重放动画
    setAnim(false);
    const raf = requestAnimationFrame(() => setAnim(true));
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return (
    <div
      className={anim ? 'route-transition' : ''}
      onAnimationEnd={() => setAnim(false)}
    >
      {children}
    </div>
  );
}
